const itemTypes = {
  'Multiple Choice': true,
  'Multiple Choice Passage': true,
  'Multiple Choice Passage Line Nums': true,
  'Content': true,
  'Directions': true,
  'Slide': true,
  'Infographic': true,
  'Infographic Two Column': true,
}

export default itemTypes


// WEBPACK FOOTER //
// ./src/config/itemTypes.js